<script>
    import { getLocaleResource } from "../utils/locales.js";
    import { locale } from "../stores.js";

    import Modal from "./Modal.svelte";

    export let showDeleteModal;

    export let deleteMessage = "";

    export let deleteCallback;
</script>

<Modal bind:showModal={showDeleteModal}>
    <div slot="title" />
    <div slot="body">
        <div class="message">
            {deleteMessage}
        </div>

        <div class="buttons">
            <button
                class="btn btn-red"
                on:click={() => {
                    deleteCallback();
                    showDeleteModal = false;
                }}
            >
                {getLocaleResource($locale, "yes")}
            </button>

            <button
                class="btn"
                on:click={() => {
                    showDeleteModal = false;
                }}
            >
                {getLocaleResource($locale, "no")}
            </button>
        </div>
    </div>
</Modal>

<style>
    .message {
        font-size: 20px;
        margin-bottom: 20px;
    }

    .buttons {
        display: flex;
        justify-content: space-around;
    }

    button {
        width: 60px;
        font-size: 20px;
        padding: 10px;
    }
</style>
